module.exports = __webpack_public_path__ + "img/page-1_img11.3a5e0749.jpg";